import { useContext } from 'react';
import JWTContextCognito from '~/contexts/JWTContextCognito';
import { JWTContextType } from '~/types/auth';

const useAuth = (): JWTContextType => {
  const authContext = JWTContextCognito;
  const context = useContext(authContext);

  if (!context) throw new Error('useAuth must be used within an AuthProvider');

  return context;
};

export default useAuth;
